import { render, staticRenderFns } from "./System.vue?vue&type=template&id=736bbd59"
import script from "./System.vue?vue&type=script&lang=ts"
export * from "./System.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports